import { render, staticRenderFns } from "./xianlu.vue?vue&type=template&id=d8b876bc&scoped=true"
import script from "./xianlu.vue?vue&type=script&lang=js"
export * from "./xianlu.vue?vue&type=script&lang=js"
import style0 from "./xianlu.vue?vue&type=style&index=0&id=d8b876bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b876bc",
  null
  
)

export default component.exports